export default class DropdownOption {
  public value: any = undefined;
  public label: string = "";
}
